module.exports = __webpack_public_path__ + "img/logo-PLANT2PRO-2020.18e53321.jpg";